import React, { useState, useEffect } from 'react';

const actionMessages = {
  save: 'Do you want to save your changes?',
  cancel: 'Are you sure you want to cancel your changes?',
  delete: 'Are you sure you want to delete your account?',
  deactivate: 'Are you sure you want to deactivate your account?',
  makePrivate: 'Are you sure you want to make all your public posts private?',
  blockMessages: 'Are you sure you want to block messages from this user?',
  unblockMessages: 'Are you sure you want to allow this user to message you again?',
  blockComments: 'Are you sure you want to block this user from commenting on your posts?',
  unblockComments: 'Are you sure you want to reallow comments from this user?',
  signOutEverywhereElse: 'Are you sure you want to sign out all other sessions?',
};


const ConfirmationDialog = ({ show, action, onConfirm, onCancel }) => {
  const [passwordInput, setPasswordInput] = useState('');

  useEffect(() => {
    if (!show) {
      setPasswordInput(''); // Reset password input when dialog closes
    }
  }, [show]);

  if (!show || !action) return null;

  const needsPassword = action === 'deactivate' || action === 'delete';
  const message = actionMessages[action] || 'Are you sure you want to proceed?';

  const handleConfirmClick = () => {
    if (needsPassword) {
      onConfirm(passwordInput);
    } else {
      onConfirm();
    }
  };

  return (
    <div id="customConfirmDialog">
      <div className="confirm-dialog-content">
        <p>{message}</p>

        {needsPassword && (
          <input
            type="password"
            value={passwordInput}
            onChange={(e) => setPasswordInput(e.target.value)}
            placeholder="Enter your password"
            className="fullTextbox"
          />
        )}

        <div className="dialog-buttons">
          <button className="confirmBtn" onClick={handleConfirmClick}>Yes</button>
          <button className="cancelBtn" onClick={onCancel}>No</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
